var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { UIButton, UIModal, UIModalContent, UIModalHeader, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MigrationModal',
    props: {
        showModel: { type: Boolean }
    },
    emits: ["completed"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const loading = ref(false);
        const errorMessage = ref('');
        const store = useStore();
        const emitter = useEmitter();
        function onclickConfirm() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (store.$state.altType === 'location') {
                        loading.value = true;
                        errorMessage.value = '';
                        yield MediaService.startMigration({
                            altId: store.$state.altId,
                            altType: store.$state.altType,
                        });
                        loading.value = false;
                        emit('completed');
                        emitter.emit('updateUI');
                    }
                }
                catch (error) {
                    console.error(error);
                    loading.value = false;
                    errorMessage.value = t('common.errorMessage');
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                width: 450,
                show: _ctx.showModel,
                id: "modal"
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "modal-header",
                        type: "primary",
                        title: `${_ctx.$t('common.migrationMergeAll')} 🎉`,
                        onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('completed')))
                    }, null, 8, ["title"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIButton), {
                        onClick: onclickConfirm,
                        id: "migrate",
                        class: "w-full mt-5",
                        type: "primary"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(loading.value ? `${_ctx.$t('common.migrationProgress')}` : `${_ctx.$t('common.ok')}`), 1)
                        ]),
                        _: 1
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UITextSmMedium), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.migrationProcessWait')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UITextSmMedium), { class: "mt-2 text-red-400" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
